module.exports = __webpack_public_path__ + "static/media/fly0288.d8b76057.webp";